import { ChangeEvent, FC } from 'react'

import {
  Button,
  Form,
  Grid,
  Input,
  Picker,
  Row,
  Select,
  SelectForm,
  Span
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { ParamFaleConoscoResponseDto } from 'services/NGT/Parameterization'
import { ITalkToUsRequestDto } from 'services/NGT/TalkToUs'
import { SPACING } from 'utils'
import { ITalkToUsSearchProps } from '../..'
import { Control } from 'react-hook-form'

interface IFilterTalkToUsProps {
  control: Control<ITalkToUsSearchProps, any>
  handleSubmit: any
  handleOnSearch: (_form?: ITalkToUsSearchProps) => void
  areDatesValid: () => boolean
  handleOnClear: () => void
  errors: any
  parametrizationTalkToUs: ParamFaleConoscoResponseDto[]
  // handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void
  // searchParams: ITalkToUsRequestDto
}

const FilterTalkToUs: FC<IFilterTalkToUsProps> = ({
  handleOnClear,
  handleOnSearch,
  areDatesValid,
  parametrizationTalkToUs,
  errors,
  control,
  handleSubmit
  // handleOnChange,
  // searchParams
}) => {

  function handleSubmitForm(form?: ITalkToUsSearchProps) {
    handleOnSearch(form)
  }

  return (
    <Form
      onSubmit={handleSubmit(handleSubmitForm)}
    >
      <Grid
        gridCols="1fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <SelectForm
          label="Motivo"
          formValue="idMotivo"
          clearSelect
          control={control}
          listOptions={parametrizationTalkToUs.map((motivo: ParamFaleConoscoResponseDto) => ({
            label: motivo.dsMotivo,
            value: motivo.idParamFaleConosco
          }))}
        // value={searchParams.idMotivo}
        // onChange={handleOnChange}
        />
      </Grid>
      <Grid
        gridCols="1.5fr 0.1fr 1.5fr 1.5fr 5fr 1.5fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          formValue="dtEnvioInicio"
          errors={errors}
          control={control}
          label="Data de"
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          formValue="dtEnvioFim"
          errors={errors}
          control={control}
          label="Data até"
        />
        <Input
          label="Usuário"
          formValue="nmUsuario"
          placeholder="Usuário"
          control={control}
        />
        <Input
          label="E-mail"
          formValue="txEmail"
          placeholder="E-mail"
          control={control}
        // value={searchParams.txEmail}
        // onChange={handleOnChange}
        />
        <SelectForm
          label="Status"
          formValue="flLiberado"
          control={control}
          listOptions={[
            { label: 'Respondido', value: 'true' },
            { label: 'Não Respondido', value: 'false' }
          ]}
        />
      </Grid>
      <Row justifyContent="flex-end" marginTop={SPACING.spacing10}>
        <Button text="Limpar" variantButton="text" onClick={handleOnClear} />
        <Button
          text="Pesquisar"
          endIcon={<MagnifyingGlassIcon />}
          disabled={!areDatesValid()}
          type={'submit'}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing10}
        />
      </Row>
    </Form>
  )
}

export default FilterTalkToUs
